import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { queryClient } from '../../../App'
import { isAdmin } from '../../../services/AccountService'
import {
  CUSTOMERS_KEYS,
  getCustomers,
} from '../../../services/CustomerApiService'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { CustomerFiltersType, defaultValues } from './useCustomerTableFilters'

export const customersPaginationStore =
  new NewPaginationStore<CustomerFiltersType>(defaultValues)

export const useCustomerTableData = () => {
  const {
    page,
    size,
    sort,
    params: {
      agreementNumber,
      customerId,
      equipmentId,
      fullAddress,
      fullName,
      phoneNumber,
      receiverSerialNumber,
    },
  } = customersPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        CUSTOMERS_KEYS.GET_CUSTOMERS,
        size,
        page,
        sort,
        userId,
        agreementNumber,
        customerId,
        equipmentId,
        fullAddress,
        fullName,
        phoneNumber,
        receiverSerialNumber,
      ],
      queryFn: () =>
        getCustomers({
          size,
          page,
          sort: sort ?? undefined,
          agreementNumber,
          customerId,
          equipmentId,
          fullAddress,
          fullName,
          phoneNumber,
          receiverSerialNumber,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId && !!isAdmin(),
      retry: 0,
    },
    queryClient,
  )
}
